// One arrival per document/checkout/offer, independent of React mounts and activity polling.
const arrivals = new Map<string, { id: string; pending: boolean; recorded: boolean }>();
export function sourcePage(referrer: string): string | undefined {
  try {
    const url = new URL(referrer);
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return undefined;
    const value = `${url.origin}${url.pathname}`;
    return value.length <= 4096 ? value : undefined;
  } catch { return undefined; }
}
export async function recordCheckoutArrival(apiBase: string, checkoutId: string, offerId?: string) {
  if (window.location.pathname !== `/c/${checkoutId}`) return;
  const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  if (navigation?.type === 'reload' || navigation?.type === 'back_forward') return;
  const key = JSON.stringify([checkoutId, offerId]);
  let arrival = arrivals.get(key);
  if (!arrival) {
    arrival = { id: crypto.randomUUID(), pending: false, recorded: false };
    arrivals.set(key, arrival);
  }
  if (arrival.pending || arrival.recorded) return;
  arrival.pending = true;
  try {
    const response = await fetch(`${apiBase}/checkouts/${encodeURIComponent(checkoutId)}/traffic`, {
      method: 'POST', keepalive: true,
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ arrivalId: arrival.id, offerId, sourcePage: sourcePage(document.referrer) }),
    });
    arrival.recorded = response.ok;
  } catch {
    // Analytics failure must not block checkout. The next activity may retry the same arrival.
  } finally { arrival.pending = false; }
}
